import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { IosModalFix } from './app/utils/ios-modal-fix';

// Aplicar parches para iOS antes de iniciar la aplicación
IosModalFix.initializePatches();

bootstrapApplication(AppComponent, {
  providers: [...appConfig.providers],
}).catch((err) => console.error(err));
